import { PermisosService, Permisos } from '../../providers/authentication/permisos.service';
import { Component, OnInit, OnDestroy, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { EspacioFormulario } from '../../domain/EspacioFormulario';
import { ConfirmationService } from 'primeng/api';
import { BreadcrumbService } from '../../breadcrumb.service';
import { TranslateService } from 'ng2-translate';

import { Message } from 'primeng/primeng';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { HistoricoLocalizacionContenido } from '../../domain/HistoricoLocalizacionContenido';

@Component({
    selector: 'app-historicotipologiaseccionchart',
	templateUrl: './historicoTipologiaSeccionChart.component.html',
	styleUrls: ['./historicoTipologiaSeccionChart.component.scss'],
    providers: [ConfirmationService]
})
export class AppHistoricoTipologiaSeccionChartComponent implements OnInit, OnDestroy {

	@Input() historicosTipologiaSeccionList: HistoricoLocalizacionContenido[];
	@ViewChild('dt') dt;
	@Output() historicoTipologiaSecciones = new EventEmitter<HistoricoLocalizacionContenido[]>();
	@Input() tipologiasSeccionesList = [];
	@Input() tipologiasList = [];
	@Input() contenidosList = [];

	historicosTipologiaSeccionListFiltrados: HistoricoLocalizacionContenido[];
    spinner: HTMLElement;
	msgs: Message[] = [];

    /* ** @INPUTS de p-dialog ** */
	public visible: boolean;

	public permisos: Permisos = new Permisos();

    public tipo_informe_seleccionado: any[];
    public tipologias_contenido_seleccionadas: any[];
	public contenidos_seleccionados: any[];
	
	public tipologiasSeccion_seccion_seleccionadas: any[];
/*
	public opcion_desde_selected;
	public opcion_hasta_selected;
	public opcion_desde_selected2;
	public opcion_hasta_selected2;
	public op2_desde;
	public op2_hasta;
	*/
    public cols3;

	public fAltaError = false;
	public fBajaError = false;

	

	public positionDialogInfoInformeY: number;
	public positionDialogInfoInformeX: number;
	public dialogDescripcionInforme: boolean = false;


	idiomaCalendario: IdiomaCalendario;
	inicio_Fecha_Desde_Filter: any;
	inicio_Fecha_Hasta_Filter: any;
	fin_Fecha_Desde_Filter: any;
	fin_Fecha_Hasta_Filter: any;
	startHourDefault: any;
	finHourDefault: any;



	constructor(
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private breadcrumbService: BreadcrumbService,
		private translate: TranslateService,
		private permisosService: PermisosService,
	) {

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Informes.Informes') }
		]);

		console.log('*** InformesComponent ***');

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
        this.spinner.style.display = 'none';

		// Tabla Historicos
		this.cols3 = [
			{ field: 'Elemento', header: this.translate.instant('Historicos.Elemento'), visible: true, width: '20%', imprimir: true, value:"" },
			{ field: 'Descripcion', header: this.translate.instant('Historicos.Descripcion'), visible: true, width: '20%', imprimir: false },
			{ field: 'Tipologias', header: this.translate.instant('Historicos.Tipologias'), visible: true, width: '15%', imprimir: true   },
			{ field: 'FechaDesde', header: this.translate.instant('Historicos.FechaDesde'), visible: true, width: '15%', imprimir: true   },
			{ field: 'FechaHasta', header: this.translate.instant('Historicos.FechaHasta'), visible: true, width: '15%', imprimir: true   },
			{ field: 'tipologiaSeccion', header: this.translate.instant('Historicos.TipologiasSeccion'), visible: true, width: '15%', imprimir: true  },
		];

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');
		this.startHourDefault = new Date();
		this.startHourDefault.setHours(0, 0, 0, 0);
		this.finHourDefault = new Date();
		this.finHourDefault.setHours(23, 59, 59, 999);
    }

	ngOnInit() {
		this.spinner.style.display = 'inherit';
		this.historicosTipologiaSeccionList = this.agruparContenidosPorSeccion(this.historicosTipologiaSeccionList);
		this.historicosTipologiaSeccionListFiltrados = this.historicosTipologiaSeccionList;
		//mando tabla a pagina 1
		if(typeof this.dt !==  'undefined'){
			this.dt.first = 0;
		}
		console.log(this.historicosTipologiaSeccionListFiltrados)
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	ngOnChanges(change) {
		console.log(change);
		this.historicosTipologiaSeccionList = this.agruparContenidosPorSeccion(this.historicosTipologiaSeccionList);
		this.historicosTipologiaSeccionListFiltrados = this.historicosTipologiaSeccionList;
		this.tipologiasList = this.tipologiasList;
		//mando tabla a pagina 1
		if(typeof this.dt !==  'undefined'){
			this.dt.first = 0;
		}
		console.log(this.historicosTipologiaSeccionListFiltrados)
	}

	onFechaChange(dt, event, columna, tipo) {
		// Centralizamos el filtrado
		this.filtrarTabla(dt, event, columna, tipo);
	}

	filtrarTabla(dt, event, columna, tipo){
		console.log(event)
		const that = this;
		that.historicosTipologiaSeccionListFiltrados = that.historicosTipologiaSeccionList;

		if(that.dt.filters){
			for (const key in that.dt.filters) {
				console.log(key, that.dt.filters[key])
				this.dt.filter(that.dt.filters[key].value, key, that.dt.filters[key].matchMode);
			}
			console.log(that.dt)
		}

		// Preparamos los valores de los filtros
		if (tipo === 'Desde') {
			if (columna === 'FechaDesde') {
				that.inicio_Fecha_Desde_Filter = event;
			}
			if (columna === 'FechaHasta') {
				that.inicio_Fecha_Hasta_Filter = event;
			}
		}
		if (tipo === 'Hasta') {
			if (columna === 'FechaDesde') {
				that.fin_Fecha_Desde_Filter = event;
			}
			if (columna === 'FechaHasta') {
				that.fin_Fecha_Hasta_Filter = event;
			}
		}

		// Aplicamos filtro FechaDesde
		that.historicosTipologiaSeccionListFiltrados = that.historicosTipologiaSeccionListFiltrados.filter(function (h) {
			let flagDesde = true;
			let flagHasta = true;
			if ((that.inicio_Fecha_Desde_Filter === undefined || that.inicio_Fecha_Desde_Filter === null) &&
				(that.fin_Fecha_Desde_Filter === undefined || that.fin_Fecha_Desde_Filter === null)) {
				return true;
			}
			if (that.inicio_Fecha_Desde_Filter !== undefined && that.inicio_Fecha_Desde_Filter !== null ) {
				flagDesde = that.inicio_Fecha_Desde_Filter <= new Date(h.FechaDesde);
			}
			if (that.fin_Fecha_Desde_Filter !== undefined && that.fin_Fecha_Desde_Filter !== null) {
				flagHasta = that.fin_Fecha_Desde_Filter >= new Date(h.FechaDesde);
			}
			return flagDesde && flagHasta;
		});

		// Aplicamos filtro FechaHasta
		this.historicosTipologiaSeccionListFiltrados = this.historicosTipologiaSeccionListFiltrados.filter(function (h) {
			let flagDesde = true;
			let flagHasta = true;
			if ((that.inicio_Fecha_Hasta_Filter === undefined || that.inicio_Fecha_Hasta_Filter === null) &&
				(that.fin_Fecha_Hasta_Filter === undefined || that.fin_Fecha_Hasta_Filter === null)) {
				return true;
			}
			if (that.inicio_Fecha_Hasta_Filter !== undefined && that.inicio_Fecha_Hasta_Filter !== null ) {
				flagDesde = that.inicio_Fecha_Hasta_Filter <= new Date(h.FechaHasta);
			}
			if (that.fin_Fecha_Hasta_Filter !== undefined && that.fin_Fecha_Hasta_Filter !== null) {
				flagHasta = that.fin_Fecha_Hasta_Filter >= new Date(h.FechaHasta);
			}
			return flagDesde && flagHasta;
		});


	}


	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		this.onFechaChange(dt, fecha, columna, tipo);
		calendar.overlayVisible=false;
	}


	changeTipologiaSeccion(event){
		console.log(event);
		console.log(this.historicosTipologiaSeccionListFiltrados)
		//this.dt.reset();
		this.historicosTipologiaSeccionListFiltrados = this.historicosTipologiaSeccionList;

		if(this.dt.filters){
			for (const key in this.dt.filters) {
				console.log(key, this.dt.filters[key])
				this.dt.filter(this.dt.filters[key].value, key, this.dt.filters[key].matchMode);
			}
			console.log(this.dt)
		}

		if(event.value.length > 0){
			let array = [];
			this.historicosTipologiaSeccionListFiltrados.forEach(elemento => {
				let existeTipologia = this.tipologiasSeccion_seccion_seleccionadas.find(t => t === elemento.SeccionFormulario.TIPOLOGIAS_SECCION[0])
				if(existeTipologia){
					array.push(elemento);
				}
			});
			this.historicosTipologiaSeccionListFiltrados = array;
		}else{
			this.historicosTipologiaSeccionListFiltrados = this.historicosTipologiaSeccionList;
		}


	}



	filterTipologia(event, columna) {
		const that = this;
		this.dt.filter(event.Nombre, columna, 'equals');
		console.log(this.historicosTipologiaSeccionListFiltrados)
	}


    /****** AUX ********/
	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}

	descripcionInforme(event){
		console.log(event)
		this.positionDialogInfoInformeX = event.x;
		this.positionDialogInfoInformeY = event.y;
		this.dialogDescripcionInforme = !this.dialogDescripcionInforme;
	}

	agruparContenidosPorSeccion(historicosList: HistoricoLocalizacionContenido[]){
		let historicosListFiltrados: HistoricoLocalizacionContenido[] = [];
		for (let index = 0; index < historicosList.length; index++) {
			let elemento: HistoricoLocalizacionContenido;
			elemento = historicosList[index];
			if(elemento.SeccionFormulario.TIPOLOGIAS_SECCION && elemento.SeccionFormulario.TIPOLOGIAS_SECCION.length > 0){
				elemento.tipologiaSeccion = elemento.SeccionFormulario.TIPOLOGIAS_SECCION[0].Nombre;
			}else{
				elemento.tipologiaSeccion = 'Sin tipología';
			}
			
			if(index === 0){
				historicosListFiltrados.push(elemento);
			}else if(elemento.tipologiaSeccion !== historicosList[index - 1].tipologiaSeccion){
				historicosListFiltrados.push(elemento)
			}else if(elemento.tipologiaSeccion === historicosList[index-1].tipologiaSeccion && elemento.Elemento === historicosList[index-1].Elemento && elemento.FechaDesde.toString() === historicosList[index - 1].FechaHasta.toString()){
				let desde = historicosList[index - 1].FechaDesde;
				elemento.FechaDesde = desde;
				historicosListFiltrados.length = historicosListFiltrados.length - 1;
				historicosListFiltrados.push(elemento)
			}else if(elemento.tipologiaSeccion === historicosList[index-1].tipologiaSeccion && elemento.Elemento === historicosList[index-1].Elemento && elemento.FechaDesde.toString() !== historicosList[index - 1].FechaHasta.toString()){
				historicosListFiltrados.push(elemento)
			}else if(elemento.Elemento !== historicosList[index - 1].Elemento){
				historicosListFiltrados.push(elemento)
			}
			
		}
		historicosListFiltrados = historicosListFiltrados.filter(h => h.tipologiaSeccion !== 'Sin tipología');
		this.historicoTipologiaSecciones.emit(historicosListFiltrados)
		//mando la tabla a la pagina 0
		if(typeof this.dt !==  'undefined'){
			this.dt.first = 0;
		}
		
		return historicosListFiltrados
	}

	seleccionarContenido(event){
		console.log(event)
		this.dt.filter(event, 'Contenido_Id', 'equals');
		console.log(this.historicosTipologiaSeccionListFiltrados)

	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/historicoTipologiaSeccionChart/historicoTipologiaSeccionChart.component.ts